module.exports = __webpack_public_path__ + "static/8-8a4fcf3b279fd3c3bd3f8d37fe65e7ed.jpg";